import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ContactBanner, whatsappUrl } from "../components/SiteShell";
import { IMAGES } from "../assets";

export function AdultPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "Executive Jiu-Jitsu Adult | Metodologia";
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const principlesList = (t("adult.principles.items", { returnObjects: true }) as Array<{
    num: string;
    title: string;
    desc: string;
  }>) || [];

  const audiencesList = (t("adult.benefits.audiences", { returnObjects: true }) as string[]) || [];

  return (
    <main>
      <section className="inner-hero adult-hero">
        <div>
          <p className="eyebrow">{t("adult.hero.eyebrow")}</p>
          <h1>
            {t("adult.hero.title").split(".")[0]}.
            <br />
            <em>{t("adult.hero.title").split(".")[1] || ""}</em>
          </h1>
          <p>{t("adult.hero.subtitle")}</p>
          <a className="button" href="#metodologia">
            {t("adult.hero.cta")}
          </a>
        </div>
        <div className="inner-portrait">
          <img src={IMAGES.professorVagner} alt="Professor Vagner Lima de kimono e faixa-preta" />
        </div>
      </section>

      <section className="editorial-section" id="metodologia">
        <p className="eyebrow">{t("adult.editorial.eyebrow")}</p>
        <h2>
          {t("adult.editorial.title").split(".")[0]}.
          <br />
          <em>{t("adult.editorial.title").split(".")[1] || ""}</em>
        </h2>
        <div className="editorial-columns">
          <p>{t("adult.editorial.p1")}</p>
          <p>{t("adult.editorial.p2")}</p>
        </div>
        <div className="method-explainer">
          <article>
            <span>01</span>
            <h3>{t("adult.editorial.step1Title")}</h3>
            <p>{t("adult.editorial.step1Desc")}</p>
          </article>
          <article>
            <span>02</span>
            <h3>{t("adult.editorial.step2Title")}</h3>
            <p>{t("adult.editorial.step2Desc")}</p>
          </article>
          <article>
            <span>03</span>
            <h3>{t("adult.editorial.step3Title")}</h3>
            <p>{t("adult.editorial.step3Desc")}</p>
          </article>
        </div>
      </section>

      <section className="executive-photo-section">
        <div className="executive-photo">
          <img
            src={IMAGES.corporativo}
            alt="Professor Vagner Lima unindo o Jiu-Jitsu ao ambiente corporativo"
          />
        </div>
        <div className="executive-photo-copy">
          <p className="eyebrow">{t("adult.corporatePhoto.eyebrow")}</p>
          <h2>
            {t("adult.corporatePhoto.title").split(".")[0]}.
            <br />
            <em>{t("adult.corporatePhoto.title").split(".")[1] || ""}</em>
          </h2>
          <p>{t("adult.corporatePhoto.p1")}</p>
          <p>{t("adult.corporatePhoto.p2")}</p>
          <blockquote>{t("adult.corporatePhoto.quote")}</blockquote>
        </div>
      </section>

      <section className="principles-section">
        <div className="section-intro light-intro">
          <p className="eyebrow">{t("adult.principles.eyebrow")}</p>
          <h2>
            {t("adult.principles.title").split(".")[0]}.
            <br />
            <em>{t("adult.principles.title").split(".")[1] || ""}</em>
          </h2>
        </div>
        <div className="principles-grid principles-preview">
          {principlesList.slice(0, 5).map((p) => (
            <article key={p.num}>
              <span>{p.num}</span>
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
            </article>
          ))}
        </div>
        <details className="principles-more">
          <summary>{t("adult.principles.viewMore")}</summary>
          <div className="principles-grid">
            {principlesList.slice(5).map((p) => (
              <article key={p.num}>
                <span>{p.num}</span>
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
              </article>
            ))}
          </div>
        </details>
      </section>

      <section className="benefits-section">
        <div>
          <p className="eyebrow">{t("adult.benefits.eyebrow")}</p>
          <h2>{t("adult.benefits.title")}</h2>
        </div>
        <div className="audience-list">
          {audiencesList.map((aud, index) => (
            <p key={index}>{aud}</p>
          ))}
        </div>
      </section>

      <section className="adult-formats">
        <div className="section-intro">
          <p className="eyebrow">{t("adult.formats.eyebrow")}</p>
          <h2>
            {t("adult.formats.title").split(".")[0]}.
            <br />
            <em>{t("adult.formats.title").split(".")[1] || ""}</em>
          </h2>
        </div>
        <div className="formats-grid">
          <article>
            <span>01</span>
            <h3>{t("adult.formats.card1Title")}</h3>
            <p>{t("adult.formats.card1Desc")}</p>
          </article>
          <article>
            <span>02</span>
            <h3>{t("adult.formats.card2Title")}</h3>
            <p>{t("adult.formats.card2Desc")}</p>
          </article>
          <article>
            <span>03</span>
            <h3>{t("adult.formats.card3Title")}</h3>
            <p>{t("adult.formats.card3Desc")}</p>
          </article>
        </div>
        <a className="button" href={whatsappUrl} target="_blank" rel="noopener noreferrer">
          {t("adult.formats.cta")}
        </a>
      </section>

      <section className="adult-ecosystem">
        <div>
          <p className="eyebrow">{t("adult.ecosystem.eyebrow")}</p>
          <h2>
            {t("adult.ecosystem.title").split(".")[0]}.
            <br />
            <em>{t("adult.ecosystem.title").split(".")[1] || ""}</em>
          </h2>
          <p>{t("adult.ecosystem.subtitle")}</p>
        </div>
        <div className="ecosystem-grid">
          <article>
            <span>01</span>
            <h3>{t("adult.ecosystem.card1Title")}</h3>
            <p>{t("adult.ecosystem.card1Desc")}</p>
          </article>
          <article>
            <span>02</span>
            <h3>{t("adult.ecosystem.card2Title")}</h3>
            <p>{t("adult.ecosystem.card2Desc")}</p>
          </article>
          <article>
            <span>03</span>
            <h3>{t("adult.ecosystem.card3Title")}</h3>
            <p>{t("adult.ecosystem.card3Desc")}</p>
          </article>
          <article>
            <span>04</span>
            <h3>{t("adult.ecosystem.card4Title")}</h3>
            <p>{t("adult.ecosystem.card4Desc")}</p>
          </article>
        </div>
      </section>

      <ContactBanner kind="adult" />
    </main>
  );
}
